<footer class="footer">
    <div class="container-fluid">
        <div class="copyright">
            © AR Franchising, Inc. <span>2023</span> All rights reserved.
        </div>				
    </div>
</footer>